import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=21470a40"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports